module.exports = __webpack_public_path__ + "img/logo03.6fdbf4d.jpg";